import { render } from "./chat.vue?vue&type=template&id=ecfa8d5c&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"

import "./chat.vue?vue&type=style&index=0&id=ecfa8d5c&lang=css"
import "./chat.vue?vue&type=style&index=1&id=ecfa8d5c&scoped=true&lang=css"

import exportComponent from "C:\\Project\\CT\\Crm-Xmarks\\crm-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecfa8d5c"]])

export default __exports__